import React from 'react';
import { Box, Card, CardContent, Divider, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Helper from '../../utility/helper';

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
}));

const PrivateTransportAccordianCard = (props) => {
    const classess = useStyles();
    const { classes, item } = props;
    const TransportationInfo = item.actualData;

    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: 'none' }}>
                <CardContent className={classess.cardContent}>
                    <Box className={classes.rowContent}>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Will You Be Using the Private Vehicle Provided by the NBA?
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}>
                                    <span>
                                        {TransportationInfo.isSelected ? 'Yes' : 'No'}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Vehicle Type
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.vehicleType === "2" ? "SUV" : "Sprinter (8-12 Pax)"}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Contact Name
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.contactName}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Contact Email
                                </Typography>
                                <Typography
                                    variant="h4"
                                    // flexGrow={1}
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.contactEmail}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box className={classes.rowContent} >
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Contact No.
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}>
                                        <span>
                                            {TransportationInfo.contactPhone}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>

                    </Box>
                    <Box className={classes.rowContent}>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    Special Request
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.specialRequest}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                width: '180px',
                                flexBasis: '180px',
                                flexGrow: 1,
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={12}
                                    fontWeight={500}
                                    color="primary">
                                    NBA Hotel
                                </Typography>
                                <Typography
                                    variant="h4"
                                    fontSize={14}
                                    fontWeight={400}
                                    style={{ wordWrap: 'break-word' }}>
                                    <span>
                                        {TransportationInfo.isHotelCheck != null ? TransportationInfo.isHotelCheck ? "Yes" : "No" : ''}
                                    </span>
                                </Typography>
                            </Box>
                        </Box>
                        {TransportationInfo.isHotelCheck != null && TransportationInfo.isHotelCheck == false ? 
                            <Box
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'left',
                                        alignItems: 'left',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={500}
                                        color="primary">
                                        Hotel Location
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        style={{ wordWrap: 'break-word' }}>
                                        <span>
                                            {TransportationInfo.location}
                                        </span>
                                    </Typography>
                                </Box>
                            </Box>
                        : null}
                    </Box>
                     
                    

                    {[1, 2, 3, 4, 5].map((item) => {
                        return (
                            <Box
                                key={`InfoSpa_${item}`}
                                sx={{
                                    width: '180px',
                                    flexBasis: '180px',
                                    flexGrow: 1,
                                    mb: 1,
                                }}></Box>
                        );
                    })}
                </CardContent>
            </Card>
        </>
    );
};

export default PrivateTransportAccordianCard;
